// extracted by mini-css-extract-plugin
module.exports = {"allArtworksBtn":"RelatedArtworks_allArtworksBtn__xWd2c"};